import API from "../../utils/endpoints";
import history from "../../history";
import * as types from "./actionType";
import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

const errorMessage = {
  status: 400,
  message: "Something went wrong",
};

function fetchingMembersReports() {
  return {
    type: types.FETCH_MEMBERS_REPORTS,
  };
}

function fetchingMembersReportsSuccess(payload, count) {
  return {
    type: types.FETCH_MEMBERS_REPORTS_SUCCESS,
    payload,
    count,
  };
}

function fetchingMembersReportsFailed() {
  return {
    type: types.FETCH_MEMBERS_REPORTS_FAILED,
  };
}

function exportingToExcel() {
  return {
    type: types.EXPORT_TO_EXCEL,
  };
}

function exportingToExcelSuccess(payload) {
  return {
    type: types.EXPORT_TO_EXCEL_SUCCESS,
    payload,
  };
}

function exportingToExcelFailed() {
  return {
    type: types.EXPORT_TO_EXCEL_FAILED,
  };
}

function fetchingNonMembersReports() {
  return {
    type: types.FETCH_NON_MEMBERS_REPORTS,
  };
}

function fetchingNonMembersReportsSuccess(payload, count) {
  return {
    type: types.FETCH_NON_MEMBERS_REPORTS_SUCCESS,
    payload,
    count,
  };
}

function fetchingNonMembersReportsFailed() {
  return {
    type: types.FETCH_NON_MEMBERS_REPORTS_FAILED,
  };
}

function fetchingRidesReports() {
  return {
    type: types.FETCH_RIDES_REPORTS,
  };
}

function fetchingRidesReportsSuccess(payload, count) {
  return {
    type: types.FETCH_RIDES_REPORTS_SUCCESS,
    payload,
    count,
  };
}

function fetchingRidesReportsFailed() {
  return {
    type: types.FETCH_RIDES_REPORTS_FAILED,
  };
}

function exportingToExcelRidesReports() {
  return {
    type: types.EXPORT_TO_EXCEL_RIDES_REPORTS,
  };
}

function exportingToExcelRidesReportsSuccess(payload) {
  return {
    type: types.EXPORT_TO_EXCEL_RIDES_REPORTS_SUCCESS,
    payload,
  };
}

function exportingToExcelRidesReportsFailed() {
  return {
    type: types.EXPORT_TO_EXCEL_RIDES_REPORTS_FAILED,
  };
}

function fetchingEventsReports() {
  return {
    type: types.FETCH_EVENTS_REPORTS,
  };
}

function fetchingEventsReportsSuccess(payload, count) {
  return {
    type: types.FETCH_EVENTS_REPORTS_SUCCESS,
    payload,
    count,
  };
}

function fetchingEventsReportsFailed() {
  return {
    type: types.FETCH_EVENTS_REPORTS_FAILED,
  };
}

function exportingToExcelEventsReports() {
  return {
    type: types.EXPORT_TO_EXCEL_EVENTS_REPORTS,
  };
}

function exportingToExcelEventsReportsSuccess(payload) {
  return {
    type: types.EXPORT_TO_EXCEL_EVENTS_REPORTS_SUCCESS,
    payload,
  };
}

function exportingToExcelEventsReportsFailed() {
  return {
    type: types.EXPORT_TO_EXCEL_EVENTS_REPORTS_FAILED,
  };
}

function fetchingBranchReports() {
  return {
    type: types.FETCH_BRANCH_REPORTS,
  };
}

function fetchingBranchReportsSuccess(payload, count) {
  return {
    type: types.FETCH_BRANCH_REPORTS_SUCCESS,
    payload,
    count,
  };
}

function fetchingBranchReportsFailed() {
  return {
    type: types.FETCH_BRANCH_REPORTS_FAILED,
  };
}

function exportingToExcelBranchReports() {
  return {
    type: types.EXPORT_TO_EXCEL_BRANCH_REPORTS,
  };
}

function exportingToExcelBranchReportsSuccess(payload) {
  return {
    type: types.EXPORT_TO_EXCEL_BRANCH_REPORTS_SUCCESS,
    payload,
  };
}

function exportingToExcelBranchReportsFailed() {
  return {
    type: types.EXPORT_TO_EXCEL_BRANCH_REPORTS_FAILED,
  };
}

function fetchingState() {
  return {
    type: types.FETCH_STATE,
  };
}

function fetchingStateSuccess(payload) {
  return {
    type: types.FETCH_STATE_SUCCESS,
    payload,
  };
}

function fetchingStateFailed() {
  return {
    type: types.FETCH_STATE_FAILED,
  };
}

export function clearingPreviousReducer() {
  return {
    type: types.CLEAR_PREVIOUS_REDUCERS,
  };
}

export const fetchMembersReports = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingMembersReports());
  try {
    let response = await api.get(
      `${API.fetchMembersReports}?page=${payload.page}&limit=${payload.count}&startDate=${payload.startDate}&endDate=${payload.endDate}&countryCode=${payload.countryCode}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingMembersReportsSuccess(response.data.data, response.data.count)
      );
    } else {
      dispatch(fetchingMembersReportsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingMembersReportsFailed(errorMessage));
  }
};

export const exportToExcel = (payload, key) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(exportingToExcel());
  try {
    let response = await api.post(
      key === "membersReports"
        ? API.exportToExcelMembersReports
        : API.exportToExcelNonMembersReports,
      payload
    );

    if (response.data.code === 200) {
      dispatch(exportingToExcelSuccess(response.data.data));
      toast.error(response.data.message);
    } else {
      dispatch(exportingToExcelFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(exportingToExcelFailed(errorMessage));
  }
};

export const fetchNonMembersReports = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingNonMembersReports());
  try {
    let response = await api.get(
      `${API.fetchNonMembersReports}?page=${payload.page}&limit=${payload.count}&startDate=${payload.startDate}&endDate=${payload.endDate}&countryCode=${payload.countryCode}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingNonMembersReportsSuccess(
          response.data.data,
          response.data.count
        )
      );
    } else {
      dispatch(fetchingNonMembersReportsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingNonMembersReportsFailed(errorMessage));
  }
};

export const fetchRidesReports = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingRidesReports());
  try {
    let response = await api.get(
      `${API.fetchRidesReports}?page=${payload.page}&limit=${payload.count}&startDate=${payload.startDate}&endDate=${payload.endDate}&countryCode=${payload.countryCode}&moderationStatus=${payload.status}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingRidesReportsSuccess(response.data.data, response.data.count)
      );
    } else {
      dispatch(fetchingRidesReportsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingRidesReportsFailed(errorMessage));
  }
};

export const exportToExcelRidesReports = (payload, key) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(exportingToExcelRidesReports());
  try {
    let response = await api.post(API.exportToExcelRidesReports, payload);

    if (response.data.code === 200) {
      dispatch(exportingToExcelRidesReportsSuccess(response.data.data));
      toast.error(response.data.message);
    } else {
      dispatch(exportingToExcelRidesReportsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(exportingToExcelRidesReportsFailed(errorMessage));
  }
};

export const fetchEventsReports = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingEventsReports());
  try {
    let response = await api.get(
      `${API.fetchEventsReports}?page=${payload.page}&limit=${payload.count}&startDate=${payload.startDate}&endDate=${payload.endDate}&countryCode=${payload.countryCode}&moderationStatus=${payload.status}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingEventsReportsSuccess(response.data.data, response.data.count)
      );
    } else {
      dispatch(fetchingEventsReportsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingEventsReportsFailed(errorMessage));
  }
};

export const exportToExcelEventsReports = (payload, key) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(exportingToExcelEventsReports());
  try {
    let response = await api.post(API.exportToExcelEventsReports, payload);

    if (response.data.code === 200) {
      dispatch(exportingToExcelEventsReportsSuccess(response.data.data));
      toast.error(response.data.message);
    } else {
      dispatch(exportingToExcelEventsReportsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(exportingToExcelEventsReportsFailed(errorMessage));
  }
};

export const fetchBranchReports = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingBranchReports());
  try {
    let response = await api.get(
      `${API.fetchBranchReports}?page=${payload.page}&limit=${payload.count}&startDate=${payload.startDate}&endDate=${payload.endDate}&countryCode=${payload.countryCode}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingBranchReportsSuccess(response.data.data, response.data.count)
      );
    } else {
      dispatch(fetchingBranchReportsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingBranchReportsFailed(errorMessage));
  }
};

export const exportToExcelBranchReports = (payload, key) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(exportingToExcelBranchReports());
  try {
    let response = await api.post(API.exportToExcelBranchReports, payload);

    if (response.data.code === 200) {
      dispatch(exportingToExcelBranchReportsSuccess(response.data.data));
      toast.error(response.data.message);
    } else {
      dispatch(exportingToExcelBranchReportsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(exportingToExcelBranchReportsFailed(errorMessage));
  }
};

export const fetchState = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingState());
  try {
    let response = await api.get(`${API.fetchDealerState}?country=${payload}`);

    if (response.data.code === 200) {
      dispatch(fetchingStateSuccess(response.data.data));
    } else {
      dispatch(fetchingStateFailed());
    }
  } catch (error) {
    dispatch(fetchingStateFailed(errorMessage));
  }
};
